<template>
  <b-card class="mb-0">
    <b-card-title class="ml-2 mb-0">{{
      $t("my_profile_page.shipping_location")
    }}</b-card-title>
    <b-row>
      <!-- Plan image -->
      <b-col cols="9" class="p-0">
        <leaflet-basic :active="active" />
      </b-col>

      <!-- Alert  -->
      <b-col cols="3" class="p-0 pr-2">
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 1</span>
          <select
            v-model="shippingState1"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 2</span>
          <select
            v-model="shippingState2"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 3</span>
          <select
            v-model="shippingState3"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 4</span>
          <select
            v-model="shippingState4"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 5</span>
          <select
            v-model="shippingState5"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 6</span>
          <select
            v-model="shippingState6"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-form-group label-for="first-name">
          <span class="input-label font-bold">State 7</span>
          <select
            v-model="shippingState7"
            id="state"
            :placeholder="$t('usps.state')"
            class="search-product form-control"
          >
            <option value="" selected>Select a state</option>
            <option
              v-for="option in options"
              :key="option.key"
              :value="option.key"
            >
              {{ option.value }}
            </option>
          </select>
        </b-form-group>
        <b-button
          variant="primary"
          class="mr-1"
          type="submit"
          @click="upgradeLocation"
        >
          {{ $t("create_company.update") }}
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BRow,
  BCol,
  BProgress,
  BAlert,
  BButton,
  BImg,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@/libs/axios";
import LeafletBasic from "@/views/charts-and-maps/maps/leaflet/LeafletUS.vue";
import { LMap } from "vue2-leaflet";
import { stateOptions } from "./../../../utils/states.js";

export default {
  name: "AccountCurrentPlan",
  components: {
    BCard,
    BCardTitle,
    BRow,
    BCol,
    BProgress,
    BAlert,
    BButton,
    BImg,
    BFormGroup,
    BFormInput,
    LeafletBasic,
    stateOptions,
  },
  props: {
    active: {
      type: Number,
    },
  },
  data() {
    return {
      options: stateOptions,
      shippingState1: "",
      shippingState2: "",
      shippingState3: "",
      shippingState4: "",
      shippingState5: "",
      shippingState6: "",
      shippingState7: "",
      userDetail: null,
    };
  },
  computed: {
    shippingStates() {
      return [
        this.shippingState1,
        this.shippingState2,
        this.shippingState3,
        this.shippingState4,
        this.shippingState5,
        this.shippingState6,
        this.shippingState7,
      ]
        .filter((state) => state.trim() !== "") // Filter out empty inputs
        .map((state) => state.toUpperCase()); // Convert to uppercase
    },
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    async getUserDetail() {
      try {
        const response = await axios.get("account/api/user/who-am-i");
        this.userDetail = response.data;
        const shippingStates = response.data.shippingStates;

        // Assign the values from shippingStates to the corresponding data properties
        this.shippingState1 = shippingStates[0] || "";
        this.shippingState2 = shippingStates[1] || "";
        this.shippingState3 = shippingStates[2] || "";
        this.shippingState4 = shippingStates[3] || "";
        this.shippingState5 = shippingStates[4] || "";
        this.shippingState6 = shippingStates[5] || "";
        this.shippingState7 = shippingStates[6] || "";
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    },
    updateShippingState(stateKey, event) {
      if (event && event.target) {
        // Remove numeric values and convert to uppercase
        const filteredValue = event.target.value
          .replace(/[^a-zA-Z]/g, "")
          .toUpperCase();
        this[stateKey] = filteredValue;
        this.checkForDuplicates(); // Check for duplicates after each update
      }
    },
    checkForDuplicates() {
      const stateCounts = {};
      this.errorMessage = ""; // Clear previous error message

      // Count occurrences of each state
      this.shippingStates.forEach((state) => {
        if (state) {
          if (!stateCounts[state]) {
            stateCounts[state] = 1;
          } else {
            stateCounts[state]++;
          }
        }
      });

      // Find duplicates and set error message
      for (const state in stateCounts) {
        if (stateCounts[state] > 1) {
          this.errorMessage = `Error: Duplicate state found - ${state}`;
          break;
        }
      }
    },
    async upgradeLocation() {
      this.checkForDuplicates(); // Check for duplicates before proceeding

      if (this.errorMessage) {
        console.log(this.errorMessage);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Shipping State Must be different from one another`,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return; // Prevent submission if there's an error
      } else {
        const payload = {
          shippingStates: this.shippingStates,
          firstName: this.userDetail.firstName,
          accountType: this.userDetail.accountType,
          affiliateId: this.userDetail.affiliateId,
          apiKey: this.userDetail.apiKey,
          companyAddress: this.userDetail.companyAddress,
          companyName: this.userDetail.companyName,
          companyRegistrationNumber: this.userDetail.companyRegistrationNumber,
          country: this.userDetail.country,
          email: this.userDetail.email,
          gdpr: this.userDetail.gdpr,
          identifier: this.userDetail.identifier,
          ipAddress: this.userDetail.ipAddress,
          isoAlpha2Country: this.userDetail.isoAlpha2Country,
          lastName: this.userDetail.lastName,
          marketingConfirmed: this.userDetail.marketingConfirmed,
          password: this.userDetail.password,
          vatNumber: this.userDetail.vatNumber,
        };

        const data = await axios.put(
          `account/api/user/update/${this.userDetail.email}`,
          payload
        );
        if (data.status === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Shipping Location Updated Successfully",
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.input-label {
  font-weight: 500;
}
</style>
